import React, { useState, useEffect } from "react";
import { IMAGES } from "../constants/theme";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Autoplay } from "swiper";
import apiClient from "../api/apiClient";

const FALLBACK_FAQS = [
  {
    id: 1,
    tag: "Training",
    level: "Beginner",
    question: "How many days per week should I train?",
    answer: "Most beginners should aim for 3–4 sessions per week for optimal recovery.",
  },
  {
    id: 2,
    tag: "Nutrition",
    level: "Beginner",
    question: "Do I need protein supplements?",
    answer: "Not necessarily. You can meet your needs through whole foods if your diet is balanced.",
  },
  {
    id: 3,
    tag: "Fat Loss",
    level: "Intermediate",
    question: "Why am I not losing weight despite training?",
    answer: "Calories, sleep, stress, and consistency all play a bigger role than workouts alone.",
  },
  {
    id: 4,
    tag: "Muscle Gain",
    level: "Beginner",
    question: "How long does it take to build muscle?",
    answer: "Visible changes usually appear after 4–8 weeks of consistent training.",
  },
  {
    id: 5,
    tag: "Recovery",
    level: "All Levels",
    question: "Is rest day really important?",
    answer: "Yes. Recovery is where muscles grow and injuries are prevented.",
  },
  {
    id: 6,
    tag: "Cardio",
    level: "Beginner",
    question: "Should I do cardio before or after weights?",
    answer: "After weights if your main goal is strength or muscle growth.",
  },
];

const bgImages = [IMAGES.overlayBoxpic1, IMAGES.overlayBoxpic2, IMAGES.overlayBoxpic3];

const GymFAQ = () => {
  const [faqs, setFaqs] = useState(FALLBACK_FAQS);

  useEffect(() => {
    apiClient.get("/homepage/faqs")
      .then(({ data }) => { if (data && data.length > 0) setFaqs(data); })
      .catch(() => {});
  }, []);

  return (
    <>
      <div className="swiper blog-slider-2">
        <Swiper
          className="swiper-wrapper"
          slidesPerView={3}
          speed={1800}
          spaceBetween={30}
          modules={[Autoplay]}
          autoplay={{ delay: 1800 }}
          breakpoints={{
            1275: { slidesPerView: 3 },
            991:  { slidesPerView: 2 },
            240:  { slidesPerView: 1 },
          }}
        >
          {faqs.map((item, ind) => (
            <SwiperSlide className="swiper-slide" key={item.id || ind}>
              <div
                className="dz-card style-2 wow fadeInUp"
                style={{ backgroundImage: `url(${bgImages[ind % bgImages.length]})` }}
              >
                <div className="post-date">
                  <span className="date">{item.tag}</span>
                  <span className="months">{item.level}</span>
                </div>

                <div className="dz-info">
                  <div className="dz-meta">
                    <ul>
                      <li className="post-author">
                        <Link to="#">
                          <img src={IMAGES.avatar2} alt="" />
                          <span>Coach Answered</span>
                        </Link>
                      </li>
                      <li className="post-comments">
                        <Link to="#">FAQ</Link>
                      </li>
                    </ul>
                  </div>

                  <h4 className="dz-title">
                    <Link to="/faq-details">{item.question}</Link>
                  </h4>

                  <p>{item.answer}</p>

                  <Link to="/faq-details" className="btn rounded-0 btn-primary btn-skew">
                    <span>View Answer</span>
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="text-center m-t50">
        <Link to="/faq" className="btn btn-secondary btn-skew">
          <span>View All FAQs</span>
        </Link>
      </div>
    </>
  );
};

export default GymFAQ;
